__turbopack_context__.v({
  "h2": "styleConstants-module__a0TjCW__h2",
});
